document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mbb-preview-root]').forEach(function (root) {
    var button = root.querySelector('[data-mbb-preview-toggle]');
    var preview = root.querySelector('[data-mbb-preview-grid]');
    if (!button || !preview) return;

    var showLabel = button.getAttribute('data-label-show') || button.textContent.trim();
    var hideLabel = button.getAttribute('data-label-hide') || 'Hide preview';

    function setState(expanded) {
      preview.hidden = !expanded;
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? hideLabel : showLabel;
    }

    setState(false);

    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      setState(!expanded);
    });
  });
});

document.addEventListener('shopify:section:load', function () {
  document.querySelectorAll('[data-mbb-preview-root]').forEach(function (root) {
    var button = root.querySelector('[data-mbb-preview-toggle]');
    var preview = root.querySelector('[data-mbb-preview-grid]');
    if (!button || !preview) return;
    preview.hidden = button.getAttribute('aria-expanded') !== 'true';
  });
});
